import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

const KEY = "lma_cookie_consent";
const SESSION_KEY = "lma_session_id";

function getSessionId(): string {
  try {
    let sid = localStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = crypto.randomUUID();
      localStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch {
    return "anon";
  }
}

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch {}
  }, []);

  async function accept() {
    try { localStorage.setItem(KEY, "accepted-" + Date.now()); } catch {}
    setVisible(false);

    // Log consent server-side (best-effort; never block UI)
    try {
      const { data: { user } } = await supabase.auth.getUser();
      await supabase.from("cookie_consents" as any).insert({
        user_id: user?.id ?? null,
        session_id: getSessionId(),
        user_agent: typeof navigator !== "undefined" ? navigator.userAgent.slice(0, 500) : null,
        consent_type: "necessary",
        consent_given: true,
        page_url: typeof window !== "undefined" ? window.location.href.slice(0, 500) : null,
      });
    } catch (e) {
      // Silent — consent is also stored locally
      // eslint-disable-next-line no-console
      console.warn("cookie consent logging failed", e);
    }
  }

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-sm z-[60] bg-[var(--color-ink)] text-white rounded-2xl shadow-2xl p-5">
      <div className="flex items-start gap-3">
        <Cookie size={20} className="text-[var(--color-gold)] shrink-0 mt-0.5" aria-hidden="true" />
        <div className="text-sm">
          <p className="font-display font-semibold mb-1">Vi använder cookies</p>
          <p className="text-white/70 text-xs leading-relaxed mb-4">
            Vi använder endast nödvändiga cookies för inloggning och säkerhet. Läs mer i vår <Link to="/access/integritetspolicy" className="underline text-[var(--color-gold)]">integritetspolicy</Link>.
          </p>
          <button onClick={accept} className="w-full bg-[var(--color-gold)] text-[var(--color-ink)] font-display font-semibold text-xs py-2.5 rounded-full hover:opacity-90 transition">
            OK, jag förstår
          </button>
        </div>
      </div>
    </div>
  );
}
